import SimpleCard from "../cards/SimpleCard";

export default function FilterCard({ title = "Filtri di ricerca", subtitle, icon, children, className = "" }) {
  return <SimpleCard as="section" aria-label={title} className={`gull-filter-card ${className}`}>
    <div className="gull-section-title">
      {icon}
      <div><h3>{title}</h3>{subtitle && <p>{subtitle}</p>}</div>
    </div>
    {children}
  </SimpleCard>;
}
